import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { CommonService } from './common.service';
import { MessageService } from './message.service';

import { environment } from '../../environments/environment';

@Injectable()
export class AbrsystemService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService
  ) { }

  private httpOptions = this.commonService.httpOptions;
  private Options  = this.commonService.Options;

  getInputHistoryList (mode:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/abrsystem/inputhistory_all/'+mode)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('inputhistory_all', []))
      );
  }
  getOutputHistoryList (mode:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/abrsystem/outputhistory_all/'+mode)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('outputhistory_all', []))
      );
  }
  deleteInputHistory (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/abrsystem/delete_inputhistory',param,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('delete_inputhistory', []))
      );
  }
  getMailHistoryList (mode:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/abrsystem/mailhistory_all/'+mode)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('mailhistory_all', []))
      );
  }
  deleteMailHistory (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/abrsystem/delete_mailhistory',param,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('delete_mailhistory', []))
      );
  }
  getAccessLog (daysmode:any,account:any){
    if (account=="") {account=null};
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/abrsystem/accesslog_all/'+daysmode+'/'+account)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('accesslog_all', []))
      );
  }
  getAccountList (){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/abrsystem/accountlist_all')
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('accountlist_all', []))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/abrsystem.service.ts